import get from 'lodash/get';

export const selectTags = (state) => get(state, 'tags.tagsList', []);
export const selectShowCreateTagModal = (state) => get(state, 'tags.showCreateTagModal', false);
